import React, {useRef} from 'react';
import {Card} from "../global/Card";
import {Line} from "../global/Line";

export const Solutions = (props) => {

  const data = props.data || {};

  const solutionsData = data.items;

  const titleRef = useRef(null);
  const labelRef = useRef(null);

  const renderSolutionsData = () => {
    return solutionsData.map((card, index) => (
      <Card
        key={index}
        color={card.color}
        title={card.title}
        text={card.text}
        image={card.image}
        button={card.button}
        classes={card.classes}
      />
    ))
  }

  return (
    <section className="py-14">
      <div className="container">
        <div className="row mb-6">
          <div className="col-md-6 col-lg-8">
            <h2 className="d-inline-flex flex-wrap align-items-start mb-0">
              <span className="zg-text-bg bg-yellow mb-1 mb-md-2">{data.titlePart1}</span>
              <span className="zg-label bg-yellow mx-2">{data.suptext1}</span>
              <span className="zg-text-bg bg-yellow mb-1 me-2 mb-md-2">{data.titlePart2}</span>
              <span className="zg-text-bg bg-orange me-2 mb-1 mb-md-2" ref={titleRef}>{data.titlePart3}</span>
              <span className="zg-label bg-orange">{data.suptext2}</span>
            </h2>
          </div>
        </div>
        <div className="row mb-11">
          <div className="col-10 col-md-4 offset-md-6 offset-1">
            <div className="mb-4">
              <span className="zg-label bg-orange me-2" ref={labelRef}>{data.number}</span>
              <span className="zg-label bg-orange">{data.subtitle}</span>
            </div>
            <p className="subtitle-md">{data.text}</p>
          </div>
        </div>
        <div className="solutions-grid">
          {renderSolutionsData()}
        </div>
        <Line start={titleRef} end={labelRef} color={"#FF9100"} classes=""/>
      </div>
    </section>
  )
}
